'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var Module3App5 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module3,
    profile: state.profile.data,
    app: state.moduleData.data.module3.app5
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3App5, _Component);

  function Module3App5() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3App5);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3App5.__proto__ || (0, _getPrototypeOf2.default)(Module3App5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 5,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'Mealtime Strategies - Feeding Part 2',
      childInvolved: _this.props.app.childInvolved || '', // Is there anything your child could do to get involved in food preparation?
      childPrepare: _this.props.app.childPrepare || '' // what can my child help with
    }, _this.handleChildInvolved = function (event) {
      var obj = _this.state;
      obj.childInvolved = event.target.value;
      obj.childPrepare = '';
      _this.setState(obj);
    }, _this.handleChildPrepare = function (event) {
      var obj = _this.state;
      obj.childPrepare = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module3App5, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var img4 = require('../Assets/img4.jpeg');
      var img5 = require('../Assets/img5.jpeg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 3'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, xs: 12, sm: 12 },
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 4: Offer a variety of foods and introduce new foods regularly'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Don\'t avoid providing foods you suspect they won\'t like or that are new'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'You can pair a new or disliked food with a liked food eg. add broccoli to a plate of mashed potato and meatballs'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Also, try not to serve the same vegetable two days in a row. This encourages children to ',
                    _react2.default.createElement(
                      'strong',
                      { className: styles.orangeText },
                      'accept variety'
                    )
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'When you offer or provide your child a disliked or new vegetable you can also provide him/her with a ',
                    _react2.default.createElement(
                      'strong',
                      { className: styles.orangeText },
                      'learning experience'
                    ),
                    ' to develop interest in healthy foods'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Eg. Did you know corn is a member of the grass family?'
              ),
              _react2.default.createElement(
                'p',
                null,
                '\xA0\xA0\xA0\xA0Broccoli is actually a baby flower that hasn\'t opened yet.'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 8, xs: 8, sm: 8 },
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 5: Make meal times relaxed'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Removing focus from food can work, eg. talk about other things, like what everyone did during the day'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Plan to serve a fruit or vegetable at every meal and snack so even if they reject the vegetables at dinner you know they have had some during the day'
                  )
                )
              ),
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 6: Get kids involved'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Some parents let their children help in the kitchen. Pre-school age children can wash vegies, mash potato, cut snow peas and beans with a plastic knife and put things away'
                  )
                )
              ),
              _react2.default.createElement(
                'h5',
                null,
                'Is there anything your child could do to get involved in food preparation?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChildInvolved.bind(this) },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'childInvolved', value: YES, checked: this.state.childInvolved === YES || this.state.childInvolved == 1 },
                  YES
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'childInvolved', value: NO, checked: this.state.childInvolved === NO || this.state.childInvolved == 0 },
                  NO
                )
              ),
              (this.state.childInvolved === YES || this.state.childInvolved == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'What would that be?'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text',
                  placeholder: 'What my child can help with...', value: this.state.childPrepare, onChange: this.handleChildPrepare.bind(this) }),
                _react2.default.createElement('br', null)
              ),
              (this.state.childInvolved === NO || this.state.childInvolved == 0) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'How about putting things back in the fridge?'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 4, xs: 4, sm: 4 },
              _react2.default.createElement(ReactBootstrap.Image, { src: img4, responsive: true }),
              _react2.default.createElement('div', { className: styles.spacer40 }),
              _react2.default.createElement(ReactBootstrap.Image, { src: img5, responsive: true })
            ),
            _react2.default.createElement('div', { className: styles.spacer100 })
          )
        )
      );
    }
  }]);
  return Module3App5;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3App5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/App/App5.js
// module id = 1200
// module chunks = 0